import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import { Container,Row,Col, Button, CardBody } from 'reactstrap';

import { ToastContainer, toast } from 'react-toastify';
import BreadCrumb from "../../Components/Common/BreadCrumb";
import {getEventById,getOEMById,baseURL} from '../../utils/calender';
import { getMyEventRegistration, registerForEvent, cancelMyEventRegistration } from '../../utils/eventRegistration';
import EventRegistrationModal from '../../Components/EventRegistration/EventRegistrationModal';

// Custom styles for event description
const eventDescriptionStyles = `
  .event-description-content {
    line-height: 1.6;
    color: #495057;
    font-size: 14px;
  }
  
  .event-description-content p {
    margin-bottom: 1rem;
    text-align: justify;
  }
  
  .event-description-content p:last-child {
    margin-bottom: 0;
  }
  
  .event-description-content h1,
  .event-description-content h2,
  .event-description-content h3,
  .event-description-content h4,
  .event-description-content h5,
  .event-description-content h6 {
    margin-top: 1.5rem;
    margin-bottom: 0.75rem;
    color: #212529;
    font-weight: 600;
  }
  
  .event-description-content h1:first-child,
  .event-description-content h2:first-child,
  .event-description-content h3:first-child,
  .event-description-content h4:first-child,
  .event-description-content h5:first-child,
  .event-description-content h6:first-child {
    margin-top: 0;
  }
  
  .event-description-content ul,
  .event-description-content ol {
    margin-bottom: 1rem;
    padding-left: 1.5rem;
  }
  
  .event-description-content li {
    margin-bottom: 0.5rem;
  }
  
  .event-description-content blockquote {
    border-left: 4px solid #dee2e6;
    padding-left: 1rem;
    margin: 1rem 0;
    font-style: italic;
    color: #6c757d;
  }
  
  .event-description-content a {
    color: #007bff;
    text-decoration: none;
  }
  
  .event-description-content a:hover {
    text-decoration: underline;
  }
  
  .event-description-content strong,
  .event-description-content b {
    font-weight: 600;
    color: #212529;
  }
  
  .event-description-content em,
  .event-description-content i {
    font-style: italic;
  }
  
  .event-description-content img {
    max-width: 100%;
    height: auto;
    border-radius: 0.375rem;
    margin: 1rem 0;
  }
  
  .event-description-content table {
    width: 100%;
    border-collapse: collapse;
    margin: 1rem 0;
  }
  
  .event-description-content th,
  .event-description-content td {
    padding: 0.5rem;
    border: 1px solid #dee2e6;
    text-align: left;
  }
  
  .event-description-content th {
    background-color: #f8f9fa;
    font-weight: 600;
  }
  
  .event-description-content .card {
    border: 1px solid #e9ecef;
    border-radius: 0.5rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  }
  
  .event-description-content .card-body {
    padding: 1.5rem;
  }
  
  .event-detail-headbg {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }
  
  .event-detail-head-title h1 {
    color: #212529;
    font-weight: 700;
    line-height: 1.2;
  }
  
  .sticky-top {
    z-index: 1020;
  }
  
  .event-date-card {
    background-color: #f8f9fa;
    border-radius: 0.375rem;
    padding: 1rem;
    border: 1px solid #e9ecef;
  }
  
  .event-date-card h2 {
    color: #007bff;
    margin: 0;
    font-size: 2rem;
  }
  
  .event-date-card .card-text {
    margin: 0;
    color: #6c757d;
    font-size: 0.875rem;
  }
  
  .contact-info p {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
  }
  
  .contact-info i {
    font-size: 1rem;
    width: 20px;
  }
  
  .card-title {
    color: #495057;
    font-weight: 600;
    font-size: 0.875rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  @media (max-width: 768px) {
    .event-description-content {
      font-size: 13px;
    }
    
    .event-description-content .card-body {
      padding: 1rem;
    }
    
    .event-detail-head-title h1 {
      font-size: 1.75rem;
    }
    
    .sticky-top {
      position: static !important;
      top: auto !important;
    }
  }
`;

const EventDetails = () => {
  const [event, setEvent] = useState(null);
  const searchParams = new URLSearchParams(location.search);
  const event_id= searchParams.get("event_id"); 
  const [OEMInfo, setOEMInfo] = useState(null);
  const [regModalOpen, setRegModalOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [myReg, setMyReg] = useState(null);
  const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
  const successnotify = (message) => toast(message, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-success text-white' });
   
  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
      const response = await getEventById(event_id);

      if (response.status === 200){
        console.log(response.data.data)
        setEvent(response.data.data);
        if (response.data.data.oem_id){
          fetchOemInformation(response.data.data.oem_id);
        }
      }
      else{
        errornotify(response.message)
      } 
      } catch (error) {
        console.error('Error fetching event details:', error);
      }
    };

    fetchEventDetails();
  }, [event_id]);

  const loadMyRegistration = async () => {
    try {
      if (!event_id) return;
      const res = await getMyEventRegistration(event_id);
      if (res?.status === 200) {
        setMyReg(res.data?.data || null);
      } else if (res?.response?.status === 404) {
        setMyReg(null);
      }
    } catch (e) {
      console.error('Failed to load my registration', e);
    }
  };

  useEffect(() => {
    loadMyRegistration();
  }, [event_id]);

  const normalizeRegistrationData = (reg) => {
    if (!reg) return {};
    const guests = reg.guests_count ?? (reg.attendees_count != null ? Math.max(0, Number(reg.attendees_count) - 1) : '');
    const attendees = reg.attendees_count ?? (reg.guests_count != null ? Number(reg.guests_count) + 1 : '');
    return {
      full_name: reg.full_name || reg.name || reg.fullName || '',
      email: reg.email || reg.email_address || '',
      phone_number: reg.phone_number || reg.phone || reg.phoneNumber || reg.mobile || '',
      guests_count: guests,
      attendees_count: attendees,
      notes: reg.notes || '',
    };
  };
  const fetchOemInformation = async (oem_id) => {
    try {
      const response = await getOEMById(oem_id);
      console.log(response);
      if (response.status === 200){ 
        setOEMInfo(response.data.data);
      }else{ 
        errornotify(response.message)
       } 
    } catch (error) {
      console.error('Error fetching event details:', error);
    }
  }
  if (!event) {
    return <div>Loading...</div>;
  }

  return (
    <div className="page-content"> 
      <style>{eventDescriptionStyles}</style>
    <Container fluid>
    <BreadCrumb title="Event Detail"  />
      <ToastContainer />
      <div className="row justify-content-center">
        <div className="col-md-8"> 
          <img src={event.images.length>0? baseURL + "/file/event/image/" +event.images[0].image_url: baseURL + "/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp"} alt={event?.title} className="img-fluid rounded event-detail-headbg mb-4" />
          <div className='event-detail-head-title'><h1 className="mt-4 mb-4">{event.title}</h1></div>
          
          {/* Event Description Section */}
          <div className="mt-4 mb-4">
            <div className="card">
              <CardBody>
                <h5 className="fs-14 text-muted mb-3">Event Description :</h5>
                {event?.description ? (
                  <div 
                    className="event-description-content"
                    dangerouslySetInnerHTML={{ __html: event.description }}
                  />
                ) : (
                  <p className="text-muted fst-italic">No description available for this event.</p>
                )}
              </CardBody>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card sticky-top" style={{ top: '2rem' }}>
            <div className="card-body">
              <Button color="success" size="lg" className="w-100 mb-4" onClick={async () => { await loadMyRegistration(); setRegModalOpen(true); }}>
                {myReg ? 'Edit registration' : 'Register'}
              </Button>
              
              <h5 className="card-title">Starts</h5>
              <div className="event-date-card mb-4">
                <Row>
                    <Col md={4}>
                    <h2> <strong>{moment(event?.start).format('D')}</strong></h2>  
                    </Col>
                    <Col md={8}>
                        <p className="card-text">
                            {moment(event?.start).format('MMMM YYYY')}<br />
                            {moment(event?.start).format('h:mm A')}
                        </p>
                    </Col>
                </Row>
              </div>
              <h5 className="card-title">Ends</h5>
              <div className="event-date-card mb-4">
                <Row>
                    <Col md={4}>
                      <h2> <strong>{moment(event.end).format('D')}</strong></h2> 
                    </Col>
                    <Col md={8}>
                        <p className="card-text">
                            {moment(event.end).format('MMMM YYYY')}<br />
                            {moment(event.end).format('h:mm A')}
                        </p>
                    </Col>
                </Row>
              </div>
              <h5 className="card-title mt-4">Location</h5>
              <p className="card-text">
                {event.location}<br /> 
              </p>
              <h5 className="card-title mt-4">Company</h5>
              <p className="card-text">
                {event.oem_company}<br /> 
              </p>
              <div className="contact-info">
                <p className="mb-2">
                  <i className="mdi mdi-phone-sync text-primary me-2"></i> 
                  <span className="text-muted">{OEMInfo?.contact_phone || 'N/A'}</span>
                </p> 
                <p className="mb-0">
                  <i className="mdi mdi-email text-primary me-2"></i> 
                  <span className="text-muted">{OEMInfo?.contact_email || 'N/A'}</span>
                </p> 
              </div>
            </div>
          </div>
        </div>
      </div> 
       </Container>
      <EventRegistrationModal
        isOpen={regModalOpen}
        toggle={() => setRegModalOpen(!regModalOpen)}
        eventId={event_id}
        prefill={normalizeRegistrationData(myReg)}
        isSubmitting={isSaving}
        onSubmit={async (payload) => {
          try {
            setIsSaving(true);
            const res = await registerForEvent(event_id, payload);
            if (res?.status === 200) {
              toast('Registration saved', { position: 'top-center', hideProgressBar: true, className: 'bg-success text-white' });
              setRegModalOpen(false);
              loadMyRegistration();
            } else {
              const msg = res?.response?.data?.message || res?.message || 'Failed to save registration';
              toast(msg, { position: 'top-center', hideProgressBar: true, className: 'bg-danger text-white' });
            }
          } catch (e) {
            toast('Failed to save registration', { position: 'top-center', hideProgressBar: true, className: 'bg-danger text-white' });
          } finally {
            setIsSaving(false);
          }
        }}
        onCancel={myReg ? async () => {
          try {
            setIsSaving(true);
            const res = await cancelMyEventRegistration(event_id);
            if (res?.status === 200) {
              toast('Registration cancelled', { position: 'top-center', hideProgressBar: true, className: 'bg-success text-white' });
              setRegModalOpen(false);
              loadMyRegistration();
            } else {
              const msg = res?.response?.data?.message || res?.message || 'Failed to cancel registration';
              toast(msg, { position: 'top-center', hideProgressBar: true, className: 'bg-danger text-white' });
            }
          } catch (e) {
            toast('Failed to cancel registration', { position: 'top-center', hideProgressBar: true, className: 'bg-danger text-white' });
          } finally {
            setIsSaving(false);
          }
        } : undefined}
      />
    </div>
  );
};

export default EventDetails;